import { ActiveCollectibles } from './active_collectibles';
import { PassiveCollectibles } from './passive_collectibles.js';

export const Collectibles = ActiveCollectibles.concat(PassiveCollectibles);